import { styled } from "styled-components";

import { LinkButton, Text } from "@vericus/cadmus-ui";

import errorIllustration from "@/assets/illustrations/man-lost-with-map.png";

type Props = {
  navigateToWork: () => void;
};

export const SocraticPageError = ({ navigateToWork }: Props) => {
  return (
    <Grid>
      <GridImg
        style={{ maxWidth: 360 }}
        src={errorIllustration}
        alt="Illustration of a man looking confused whilst holding a map with a university building in the background"
      />
      <GridContent>
        <Text kind="displayTwo">Something went wrong</Text>
        <Text kind="lead">
          We were unable to load this page. Please{" "}
          <LinkButton kind="primary" onClick={navigateToWork}>
            return to the previous page
          </LinkButton>{" "}
          and try again.
        </Text>
      </GridContent>
    </Grid>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  grid-column-gap: 27px;
  justify-content: center;

  width: 100%;
  max-width: 1440px;
  padding-left: 48px;
  padding-right: 48px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
`;

const GridImg = styled.img`
  grid-column: 3 / span 5;
  width: 100%;
  margin-top: 72px;
  justify-self: center;

  @media screen and (max-width: 900px) {
    grid-column: 2 / span 7;
  }

  @media screen and (max-width: 630px) {
    grid-column: 1 / span 9;
  }
`;

const GridContent = styled.div`
  grid-column: 3 / span 5;
  text-align: center;
  margin-top: 18px;

  @media screen and (max-width: 900px) {
    grid-column: 1 / span 9;
  }
`;
